(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.administration', [
        'uwAgenda.global'
    ]);
    module.config(['$stateProvider', SettingsConfig]);
    module.constant('ThirdPartyEnum', {
        "OfficeSuite365": { name: 'OfficeSuite365', value: 2 },
        "CielComm": { name: 'CielComm', value: 3 },
        "IntroCare": { name: 'IntoCare', value: 4 },
        "CliniNET": { name: 'CliniNET', value: 5 },
        "DentalAdmin": { name: 'DentalAdmin', value: 6 },
        "Medibase": { name: 'Medibase', value: 7 },
        "EyeFile": { name: 'EyeFile', value: 8 }
    });


    function SettingsConfig($stateProvider) {
        $stateProvider
            .state('Home.Administration', {
                url: 'Administration',
                templateUrl: '/app/settings/administration/templates/administration.template.html',
                controller: 'AdministrationController',
                controllerAs: 'vm',
                resolve: {
                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda Administrations',
                            serie: true,
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/profile.css',
                                '/assets/lib/lazy-loaded/todo-2.min.css',
                                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.css',

                                '/assets/lib/lazy-loaded/todo-2.min.js',
                                '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                                '/assets/lib/lazy-loaded/bootstrap-timepicker.min.js',

                                '/assets/lib/lazy-loaded/profile.min.js'
                            ]
                        });
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'admin_settings' | translate}}"
                }
            })

            .state('Home.Administration.Protocols', {
                url: '/Settings/Protocols/:userId',
                templateUrl: '/app/settings/administration/modules/protocols/templates/protocol-overview.template.html',
                controller: 'ProtocolOverviewController',
                controllerAs: 'vm',
                params: {
                    all: false
                },
                resolve: {
                    protocols: ['ProtocolService', 'SharedAgendaService', '$stateParams', function (ProtocolService, SharedAgendaService, $stateParams) {
                        if ($stateParams.userId) {
                            return ProtocolService.query($stateParams.userId, $stateParams.all, null);
                        }
                        else {
                            return ProtocolService.queryAll($stateParams.all);
                        }
                    }],
                    selectedUser: ['SharedAgendaService', 'UserService', '$stateParams', function (SharedAgendaService, UserService, $stateParams) {
                        if ($stateParams.userId) {
                            return UserService.get($stateParams.userId, SharedAgendaService.currentUser().id, SharedAgendaService.data.currentAgenda.id);
                        }
                        else { return null; }
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'protocols' | translate}}"
                }
            })
            .state('Home.Administration.ProtocolCategories', {
                url: '/Settings/ProtocolCategories',
                templateUrl: '/app/settings/administration/modules/protocolcategories/templates/protocol-category-overview.template.html',
                controller: 'ProtocolCategoryOverviewController',
                controllerAs: 'vm',
                resolve: {
                    protocolCategories: ['ProtocolCategoryService', '$stateParams', function (ProtocolCategoryService, $stateParams) {
                        return ProtocolCategoryService.query($stateParams.all);
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'protocol_categories' | translate}}"
                }
            })

            .state('Home.Administration.SyncSettings', {
                url: '/Settings/SyncSettings',
                templateUrl: '/app/settings/administration/modules/syncsettings/templates/syncsettings-overview.template.html',
                controller: 'SyncSettingsOverviewController',
                controllerAs: 'vm',
                params: {
                    all: false
                },
                resolve: {
                    synchronisations: ['SynchronisationExternService', '$stateParams', function (SynchronisationExternService, $stateParams) {
                        return SynchronisationExternService.query($stateParams.all);
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'syn_settings' | translate}}"
                }
            })

            .state('Home.Administration.ThirdPartyApps', {
                url: '/Settings/ThirdPartyApps',
                templateUrl: '/app/settings/administration/modules/thirdpartyapps/templates/third-party-app-overview.template.html',
                controller: 'ThirdPartyAppOverviewController',
                controllerAs: 'vm',
                params: {
                    all: false
                },
                resolve: {
                    apps: ['ThirdPartyAppService', '$stateParams', function (ThirdPartyAppService, $stateParams) {
                        return ThirdPartyAppService.query($stateParams.all);
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'third_party_apps' | translate}}"
                }
            })
            
            .state('Home.Administration.RingphoneOffices', {
                url: '/settings/ringphone-locations',
                templateUrl: '/app/settings/administration/modules/ringphone-offices/ringphone-offices-overview.html',
                controller: 'RingphoneOfficesOverviewController',
                controllerAs: 'vm',               
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'ringphone_offices' | translate}}"
                }
            })

            .state('Home.Administration.Licences', {
                url: '/Settings/Licences',
                templateUrl: '/app/settings/administration/modules/licences/templates/licences-overview.template.html',
                controller: 'LicencesOverviewController',
                controllerAs: 'vm',
                resolve: {
                    licences: ['LicenceService', function (LicenceService) {
                        return LicenceService.queryLicence();
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'licences' | translate}}"
                }
            })

            .state('Home.Administration.LicenceDetail', {
                url: '/Settings/Licences/Detail/:licenceId',
                templateUrl: '/app/settings/administration/modules/licences/templates/edit-licence.template.html',
                controller: 'EditLicenceController',
                controllerAs: 'vm',
                resolve: {
                    licence: ['$stateParams', 'LicenceService', function ($stateParams, LicenceService) {
                        // edit or new
                        if ($stateParams.licenceId) {
                            return LicenceService.getLicence($stateParams.licenceId, true);
                        } // if
                        else {
                            // return null -> new Licence Object will be created
                            return null;
                        }
                    }],

                    templatePrefixes: ['AdministrationService', function (AdministrationService) {
                        return AdministrationService.templatePrefixes();
                    }],

                    deps: ['$ocLazyLoad', function ($ocLazyLoad) {
                        return $ocLazyLoad.load({
                            name: 'uwAgenda LicenceDetail',
                            serie: true,
                            insertBefore: '#ng_load_plugins_before',
                            files: [
                                '/assets/lib/lazy-loaded/bootstrap-fileinput.css',
                                '/assets/lib/lazy-loaded/profile.css',

                                '/assets/lib/lazy-loaded/jquery.sparkline.min.js',
                                '/assets/lib/lazy-loaded/bootstrap-fileinput.js',

                                '/assets/lib/lazy-loaded/profile.min.js'
                            ]
                        });
                    }]
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    parent: 'Home.Administration.Licences',
                    label: "{{vm.ncyLabel | translate}}"
                }
            })
            .state('Home.Administration.GroupPractice', {
                url: '/grouppractice',
                templateUrl: '/app/settings/administration/modules/grouppractice/templates/grouppractice-overview.template.html',
                controller: 'GroupPracticeOverviewController',
                controllerAs: 'vm',  
                params: {
                    all: false
                },
                // resolve: {
                //     protocolCategories: ['ProtocolCategoryService', '$stateParams', function (ProtocolCategoryService, $stateParams) {
                //         return ProtocolCategoryService.query($stateParams.all);
                //     }]
                // },                        
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'grouppractice' | translate}}"
                }
            });
    }
})();